/** Junta classes ignorando falsy (sem dependência nova: política de versões fixas). */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
